// extracted by mini-css-extract-plugin
export default {"dropdownItem":"TenantRentalIncomeTracking_dropdownItem__sZzUF"};